document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.image-product__container');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');
  const customDots = document.querySelector('.custom-slider');

  containers.forEach(function (container) {
    if (!container) return;
    const items = container.querySelectorAll('.image-product__item');
    if (items.length < 2) return;

    if (prevBtn) prevBtn.classList.add('has-slide');
    if (nextBtn) nextBtn.classList.add('has-slide');
    if (customDots) customDots.classList.add('has-slide');

    const flkty = new Flickity(container, {
      cellAlign: 'center',
      contain: true,
      wrapAround: false,
      prevNextButtons: false,
      pageDots: false,
    });

    flkty.on('select', function () {
      items.forEach((item, index) => {
        item.classList.toggle('is-selected', index === flkty.selectedIndex);
      });
    });

    function updateButtonState() {
      if (prevBtn) {
        prevBtn.disabled = flkty.selectedIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = flkty.selectedIndex === flkty.slides.length - 1;
      }
    }

    updateButtonState();

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        flkty.previous();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        flkty.next();
      });
    }

    if (customDots) {
      flkty.cells.forEach((cell, index) => {
        const dot = document.createElement('span');
        dot.classList.add('slider-dot');
        if (index === flkty.selectedIndex) dot.classList.add('is-active');

        dot.addEventListener('click', () => flkty.select(index));
        customDots.appendChild(dot);
      });

      flkty.on('change', function (index) {
        const allDots = customDots.querySelectorAll('.slider-dot');
        allDots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      });
    }

    flkty.on('select', updateButtonState);
  });
});
